/**
 * The map the user last opened from the Maps index, remembered per user so
 * the index can mark it. Going back to the index does not clear it. Never a
 * source for which group Find subscribes to — looking at a map touches no
 * BLE session.
 */
const KEY_PREFIX = 'prii.map.selectedEvent.';

export function readStoredMapEventId(userId) {
  if (!userId) return null;
  try {
    return window.localStorage.getItem(KEY_PREFIX + userId) || null;
  } catch {
    return null;
  }
}

export function writeStoredMapEventId(userId, eventId) {
  if (!userId) return;
  try {
    if (eventId) window.localStorage.setItem(KEY_PREFIX + userId, eventId);
    else window.localStorage.removeItem(KEY_PREFIX + userId);
  } catch {
    /* private mode */
  }
}
